import './App.css';
import TempScale from './components/TempScale';
function App() {
  // const data = FetchData("pi.txt");
  return (
    <div className="App">
      <h1>Weather App</h1>
      <TempScale></TempScale>
      </div>
  );
}

export default App;
